export const capitalize = (value: string): string => {
    return value ? value.slice(0, 1).toUpperCase() + value.slice(1) : '';
}
export const camelCase = (value: string): string => {
    return value.split(/[\s\-_]/g).map((word: string) => capitalize(word)).join('');
}

export default {
    capitalize: capitalize,
    camelCase: camelCase,
    phone: (value: string) => {
        let regexp = new RegExp('^(\\+[0-9]{3})([0-9]{2})([0-9]{3})([0-9]{2})([0-9]{2})$');
        return value.match(regexp) ? value.replace(regexp, '$1 ($2) $3-$4-$5') : value;
    },
    noSpace: (value: string) => {
        return value.replace(/\s/g, '');
    },
    fill: (value: string, len: number = 2, placeholder: string = '0') => {
        let res = value.toString();
        if (res.length < len) {
            for (let i = 0; i < len - res.length; i++) {
                res = placeholder + res;
            }
        }
        return res;
    },
    link: (value: string) => {
        return value ? ((value?.match(/^http(s?):\/\//g) ? '' : 'https://') + value) : '';
    },
    trim: (value: number) => {
        return value.toString().replace(/\.0+$/g, '');
    }
}
